import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/activity", { params: { limit: 500 } }).then((r) => setLogs(r.data)); }, []);
  return (
    <div className="space-y-5">
      <div>
        <h1 className="heading text-2xl font-bold text-slate-900">Activity Logs</h1>
        <p className="text-sm text-slate-500 mt-1">Every status change, edit and action across the system.</p>
      </div>
      <Card className="border border-slate-200 shadow-none overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wide">
              <tr>
                <th className="p-3 text-left">Time</th>
                <th className="p-3 text-left">Actor</th>
                <th className="p-3 text-left">Role</th>
                <th className="p-3 text-left">Action</th>
                <th className="p-3 text-left">Status Change</th>
                <th className="p-3 text-left">Order</th>
                <th className="p-3 text-left">Remarks</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {logs.map((l) => (
                <tr key={l.id} className="table-row-hover">
                  <td className="p-3 text-xs text-slate-600">{fmtDateTime(l.timestamp)}</td>
                  <td className="p-3 font-medium text-slate-900">{l.actor_name}</td>
                  <td className="p-3 text-xs uppercase tracking-wide text-slate-600">{l.actor_role}</td>
                  <td className="p-3 text-slate-700">{l.action.replace(/_/g, " ")}</td>
                  <td className="p-3 text-xs text-slate-600">{l.old_status ? `${l.old_status} → ${l.new_status}` : l.new_status || "-"}</td>
                  <td className="p-3 text-xs"><Link className="text-blue-600 hover:underline mono" to={`/orders/${l.order_id}`}>Open</Link></td>
                  <td className="p-3 text-slate-600 text-xs">{l.remarks || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
